import React from 'react';

const Loader = () => {
  
 return (
  <div className = "centered">
    <div className="lds-grid">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
 );
};

export default Loader;